import notificationService from '../services/notificationService';
import {selectIsOnline} from '../state/selectors/global';
import {getState} from '../state/store';
import helpers from '../utils/helpers';

const useConnectionCheck = ({action, isOnlineCheck = true}) => {
    const connectionCheck = (e) => {
        const isOnline = selectIsOnline(getState());

        if (isOnlineCheck && !isOnline) {
            notificationService.showNetworkWarning();
            return;
        }

        helpers.runFunction(action, e);
    };

    return connectionCheck;
};

export default useConnectionCheck;
